'use strict'

import { apiInstance, legacyV3 } from './index'
import { mapArgs } from 'utils/functions'

const companyGroup = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV3()}/companygroup`,
      params
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3()}/companygroup`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/companygroup/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV3()}/companygroup/${id}`
    })
  }
}

export default companyGroup
